export default {
  MY_PROFILE: `Mes informations`,
  CONTACT_INFO: {
    TITLE: `Mes informations de contact`,
    SUMMARY: `Ces informations sont utilisées afin de vous communiquer les annonces, les notifications de quart de travail, les offres de quart de travail, etc.`
  },
  LOGIN_INFO: {
    TITLE: `Mes informations de connexion`,
    SUMMARY: `Cette section vous permet de modifier vos informations de connexion pour accéder à l'application web, l'application mobile ou bien au système vocal.`
  },
  DELETE_BUTTON: {
    TITLE: `Supprimer la photo de profil`,
    SUMMARY: `Êtes-vous certain de vouloir supprimer cette photo ?`,
    PRIMARY_ACTION: `Supprimer la photo`
  },
  MY_PASSWORD_AND_PHONEPIN: `Mon mot de passe / NIP téléphonique`,
  MY_EMAILS: `Mes adresses courriel`,
  ADD_EMAIL: `Ajouter une adresse courriel`,
  MY_PHONE_NUMBERS: `Mes numéros de téléphone`,
  ADD_PHONE_NUMBER: `Ajouter un numéro de téléphone`,
  EDIT_EMAILS: `Modifier mes adresses courriels`,
  EDIT_PHONE_NUMBERS: `Modifier mes numéros de téléphone`,
  MISSING_CONTACT_INFO: `Il vous manque un numéro de téléphone ou une addresse courriel, il se peut que vous ne receviez pas certaines communications importantes dans le futur.`,
  CHANGE_USERNAME: `Modifier mon nom d'utilisateur`,
  CHANGE_PASSWORD: `Modifier mon mot de passe`,
  CHANGE_PIN: `Modifier mon NIP téléphonique`,
  USERNAME: {
    LABEL: `Nom d'utilisateur`,
    PLACEHOLDER: `Entrez le nouveau nom d'utilisateur`,
    DESCRIPTION: ``
  },
  CONFIRMUSERNAME: {
    LABEL: `Confirmation du nom d'utilisateur`,
    PLACEHOLDER: `Confirmez le nouveau nom d'utilisateur`,
    DESCRIPTION: ``
  },
  ACTUALPASSWORD: {
    LABEL: `Mot de passe actuel`,
    PLACEHOLDER: `Entrez votre mot de passe`,
    DESCRIPTION: ``
  },
  PASSWORD: {
    PLACEHOLDER: `Entrez un nouveau mot de passe`,
    LABEL: `Nouveau mot de passe`,
    DESCRIPTION: `Votre mot de passe doit contenir au entre 8 et 64 caractères`
  },
  CONFIRMPASSWORD: {
    LABEL: `Confirmation du mot de passe`,
    PLACEHOLDER: `Confirmez votre nouveau mot de passe`,
    DESCRIPTION: ``
  },
  PIN: {
    LABEL: `NIP téléphonique`,
    PLACEHOLDER: `Entrez votre nouveau NIP téléphonique`,
    DESCRIPTION: ``
  },
  CONFIRMPIN: {
    LABEL: `Confirmation du NIP téléphonique`,
    PLACEHOLDER: `Confirmez votre nouveau NIP téléphonique`,
    DESCRIPTION: ``
  },
  ADDRESS: {
    LABEL: `Adresse courriel`,
    PLACEHOLDER: `Entrez votre adresse courriel`,
    DESCRIPTION: ``
  },
  TYPE: {
    LABEL: `Type`,
    PLACEHOLDER: ``,
    DESCRIPTION: ``
  },
  PHONENUMBER: {
    LABEL: `Numéro de téléphone`,
    PLACEHOLDER: `Entrez votre numéro de téléphone`,
    DESCRIPTION: ``
  },
  CALL: {
    LABEL: `Préférence de contact`,
    DESCRIPTION: `Recevoir uniquement un appel`
  },
  SMS: {
    LABEL: `Préférence de contact`,
    DESCRIPTION: `Recevoir uniquement un message texte`
  },
  CALL_THEN_SMS: {
    LABEL: `Préférence de contact`,
    DESCRIPTION: `Recevoir un appel, suivi d'un message texte (uniquement s’il n’y a pas de réponse à l’appel)`
  },
  DO_NOT_USE: {
    LABEL: `Préférence de contact`,
    DESCRIPTION: `Ne pas utiliser ce numéro`
  },
  QUIT_PAGE: `Les modifications n'ont pas encore été sauvegardées, êtes-vous certain(e) de vouloir quitter la page ?`,
  MANDATORY_USERNAME: `Votre nom d'utilisateur est requis`,
  MANDATORY_CONFIRM_USERNAME: `Vous devez confirmer votre nom d'utilisateur`,
  MANDATORY_ACTUAL_PASSWORD: `Le champ du mot de passe actuel est requis`,
  MANDATORY_PASSWORD: `Le champ du mot de passe est requis`,
  MANDATORY_CONFIRM_PASSWORD: `Vous devez confirmer votre mot de passe`,
  MANDATORY_PIN: `Votre NIP téléphonique est requis`,
  MANDATORY_CONFIRM_PIN: `Vous devez confirmer votre NIP téléphonique`,
  MANDATORY_ADDRESS: `Votre adresse courriel est requise`,
  MANDATORY_PHONE_NUMBER: `Votre numéro de téléphone est requis`,
  MANDATORY_TYPE: `Votre type est requis`,
  INVALID_LENGTH: `La longueur du mot de passe est invalide`,
  INVALID_FORMAT: `Le format est invalide`,
  INVALID_EMAIL: `L'adresse courriel doit être valide.`,
  INVALID_PHONE_NUMBER: `Le format est invalide, il doit comporter 10 chiffres.`,
  WRONG_PASSWORD: `Le mot de passe que vous avez entré est invalide. Veuillez entrer votre mot de passe actuel dans le champ prévu à cet effet.`,
  CONFIRMATION_FIELD_MUST_MATCH: `Ne correspond pas au mot de passe entré plus haut`,
  INVALID_PIN_FORMAT: `Votre mot de passe doit contenir entre 4 et 8 chiffres`,
  PASSWORD_REQUIREMENT: `Votre mot de passe doit contenir au entre 8 et 64 caractères`,
  ALREADY_IN_USE: `Ce nom d'utilisateur est déjà pris`,
  MAX_PHONE_NUMBERS_REACHED: `Vous avez atteint la limite, veuillez supprimer un numéro pour pouvoir en ajouter un autre`,
  UPDATING_PHONES_DISABLED: `La modification des numéros de téléphone a été désactivée, faites appel à votre gestionnaire si vous devez apporter des modifications`,
  UPDATING_EMAILS_DISABLED: `La modification des adresses courriel a été désactivée, faites appel à votre gestionnaire si vous devez apporter des modifications`,
  INVALID_CODE: {
    title: `Code de vérification invalide`,
    description: `Le code que vous avez entré est invalide, veuillez le vérifier et le soumettre à nouveau.`
  },
  VERIFICATION_CODE_EXPIRED: {
    title: `Code de vérification expiré`,
    description: `Le code que vous avez entré est expiré. Veuillez demander un nouveau code.`
  },
  ERROR_DURING_VERIFICATION: { title: `Erreur durant la vérification`, description: `Une erreur est survenue durant la vérification, veuillez réessayer.` },
  EMAIL_VERIFICATION_FAILED: {
    title: `Erreur durant la vérification de l'adresse courriel`,
    description: `Une erreur est survenue lors de l'envoi du courriel de vérification, veuillez vérifier votre adresse courriel et réessayer.`
  },
  ERROR_UPDATING_PRONOUNS: {
    title: `Erreur durant la modification des pronoms`,
    description: `Une erreur est survenue durant la modifitcation de vos pronoms, veuillez réessayer.`
  },
  SMS_VERIFICATION_FAILED: {
    title: `Code de vérification du numéro de téléphone`,
    description: `Une erreur est survenue lors de l'envoi du message texte, veuillez vérifier votre numéro de téléphone et réessayer.`
  },
  ENTER_THE_CONFIRMATION_CODE: `Entrez le code de confirmation`,
  RESEND_CONFIRMATION_CODE: `Envoyer un nouveau code`,
  YOU_CAN_ADD_ONLY_ONE_NUMBER_AT_A_TIME: `Vous pouvez seulement ajouter un numéro de téléphone à la fois. Veuillez sauvegarder les modifications afin de pouvoir ajouter d'autres numéros par la suite.`,
  YOU_CAN_ADD_ONLY_ONE_EMAIL_AT_A_TIME: `Vous pouvez seulement ajouter une adresse courriel à la fois. Veuillez sauvegarder les modifications afin de pouvoir ajouter d'autres adresses courriel par la suite.`,
  PERSONAL_INFO: {
    TITLE: `Mes informations personnelles`,
    SUMMARY: `Cette section vous permet de consulter les informations de votre profil personnel. Si vous trouvez une erreur, cliquez sur “Demander des modifications” et décrivez-là dans la boîte de dialogue.`,
    MY_BIRTH_DATE: `Ma date de naissance`,
    MY_SENIORITY: `Mon ancienneté`,
    MY_DEPARTMENTS: `Mes départements`,
    MY_EMERGENCY_CONTACTS: `Mes contacts d'urgence`,
    MY_HIRING_DATA: `Mes données d’embauche`,
    permitType: `Permis`,
    employeeType: `Type d'employé`,
    contractType: `Contrat`,
    REQUESTED_CHANGES: `Modifications demandées`,
    REASON_FOR_CHANGES: `Raisons de la demande`,
    CANCEL_CHANGE_REQUEST: `Annuler la demande de modification`,
    MY_ATTRIBUTES: `Mes attributs`,
    MY_PRONOUNS: `Mes pronoms`
  },
  ISVALIDTEXT: {
    LABEL: `Demander des modifications`,
    PLACEHOLDER: `Entrez une description des changements à effectuer`,
    DESCRIPTION: `Votre gestionnaire aura accès à ces informations et pourra effectuer des modifications.`
  },
  MANDATORY_REASON: `Veuillez entrer une raison pour les changements.`,
  SWITCH_PROFILE_PICTURE: `Utiliser cette adresse courriel comme photo de profil`,
  HOW_TO_EDIT_PROFILE_PICTURE: `Vous pouvez modifier votre photo de profil sur Gravatar`,
  EDIT_MY_ASSIGNABLE_ATTRIBUTES: `Modifier mes attributs auto-assignables`,
  EDIT_MY_PRONOUNS: `Modifier mes pronoms`,
  MISSING_PRONOUN: `Veuillez spécifier un pronom.`,
  CROP_AND_UPLOAD: `Recadrer et sauvegarder`,
  editAttributes: {
    CAN_EDIT_ONLY_SELF_ASSIGNABLE: `Seulement les attributs marqués comme assignables par les employés peuvent être ajoutés ou supprimés.`,
    ATTRIBUTES: {
      TITLE: `Attributs`,
      LABEL: `Attributs`,
      DESCRIPTION: `Ajouter ou retirer des attributs selon vos compétences et préférences.`
    }
  },
  PROFILEPICTUREUPLOAD_MODAL: {
    TITLE: `Modifier la photo de profil`,
    SUMMARY: ''
  }
}
